import React, {useRef, useState} from "react";
import {isEmpty} from "../../../clases/validator";
import EmptyS from "../../atoms/EmptyS";
import Popup from "reactjs-popup";
import Icon from "../../atoms/Icon";
import {Link} from "react-router-dom";
import {API_BASE_URL} from "../../../clases/request";
import toast from "react-hot-toast";

const Table2 = ({
                    headers,
                    tableData,
                    heightEmptyState,
                    emptyText,
                    pageNumber,
                    operations,
                    hasOperation,
                    limit
                }) => {

    if (!isEmpty(tableData)) {
        return (<div
            className={`flex flex-col justify-center items-center  m-7.5px  ${heightEmptyState}`}>
            <EmptyS text={emptyText}/>
        </div>);
    }

    function isNumeric(value) {
        return /^-?\d+$/.test(value);
    }

    function isEnglishOrPersian(text) {

        const persianRegex = /[\u0600-\u06FF\u0750-\u077F]/; // Persian character range
        const englishRegex = /[A-Za-z]/; // English character range

        if (persianRegex.test(text)) {
            return "persian";
        } else if (englishRegex.test(text)) {
            return "english";
        } else {
            return "unknown"; // Neither English nor Persian
        }
    }

    const getLinkUrl = (operation, data) => {
        if (operation.downloadQRCode) {
            return operation.link.replace("SERIAL", data.serialNumber);
        }
        if (operation.isLinkWithId) {
            return operation.link + "?" + operation.linkKey + "=" + (operation.linkKey === "serial" ? data.serialNumber : data.id);
        }
        return operation.link;
    };

    const renderLink = (operation, data) => {
        const linkUrl = getLinkUrl(operation, data)
        if (operation.downloadQRCode) {
            return (
                <a
                    href={linkUrl}
                    download={"kimia.png"}>
                    <Icon
                        iconName={operation.iconName}
                        className="w-5 h-5 cursor-pointer"
                        data={data.id}
                    />
                </a>
            )
        }
        return (<Link
            className={`${operation.isIconRed ? "active-iconR" : "active-icon"}`}
            rel='noopener noreferrer'
            to={linkUrl} target={`${operation.linkOpenInNewTab ? '_blank' : '_self'}`}>
            <Icon
                iconName={operation.iconName}
                className={`${operation.isIconRed ? "active-iconR" : "active-icon"}
                    h-5 w-5 cursor-pointer ${operation.className}`}
                onClick={(event) => {
                    operation.onClick(event);
                }}
            >
            </Icon>
        </Link>);
    }

    const renderIcon = (operation, data, index) => {
        return (<button>
            <Icon
                iconName={operation.iconName}
                className={`${operation.isIconRed ? "active-iconR" : "active-icon"} 
                    h-5 w-5 cursor-pointer ${operation.className}`}
                onClick={(event) => {
                    operation.onClick(data);
                }}
                // data={"12345"}
                data={JSON.stringify(data)}
                // data={id}
            >
            </Icon>
        </button>)
    }

    const renderOperation = (operation, data, index) => {
        let triggerComponent;
        if (operation.link) {
            triggerComponent = renderLink(operation, data);

        } else {
            triggerComponent = renderIcon(operation, data, index)
        }

        return triggerComponent;
    }


    const copyToClipboard = (data, e) => {
        navigator.clipboard.writeText(data)
        toast.success("کپی شد", {
            className: "text-12 text-dark-blue-200",
        });
    };

    return (<div className="border-gray border-1 border-solid rounded-sm">
        <table className=" w-full text-dark-blue-200">
            {/* Table header */}
            <thead className="text-13 max-[1200px]:text-10  bg-gray-300">
            {/* Row number column */}
            <tr>
                <th
                    className={'py-3.5 font-normal rounded-tl-md text-right  pl-8 pr-4 '}>
                    ردیف
                </th>
                {headers.map((th) => {
                    return (<th
                        className={`py-3.5 font-normal text-right first:rounded-r-sm first:pr-7.5px last:pl-7.5px w-16`}
                        key={th.key}>
                        {th.name}
                    </th>);
                })}
                {hasOperation && (<th
                    className={`py-3.5 font-normal rounded-tl-md text-right pl-7.5px`}>
                    عملیات
                </th>)}
            </tr>
            </thead>
            <tbody className="">
            {tableData.map((data, index) => {
                return (<tr

                    key={index}
                    className={`text-13 max-[1200px]:text-10 font-normal border-b-1 border-gray last:border-b-0 cursor-pointer`}>
                    <td className="text-right pr-7">
                        {index + 1 + limit * (pageNumber - 1)}
                    </td>
                    {headers.map((td) => {
                        return (<td
                            onClick={() => {
                                copyToClipboard(data[td.key], td)

                            }}
                            className={`py-3.5 font-normal first:pr-7.5px ${isNumeric(data[td.key]) || isEnglishOrPersian(data[td.key]) === "english" ? "tracking-wider" : ""} `}
                            key={td.key}>
                            {data[td.key]}
                        </td>);
                    })}

                    {hasOperation && (<td>
                        <div
                            className={`flex flex-row-reverse pl-7.5px h-12.5 
                                        items-center justify-end gap-5 max-[1200px]:gap-2.5`}>
                            {operations.map((operation) => {
                                return <div
                                    key={operation.iconName}
                                    className="flex">
                                    <Popup
                                        trigger={() => {
                                            return renderOperation(operation, data, index)

                                        }}
                                        on={["hover", "focus"]}
                                        position="top center">

                                        <span> {operation.popupTitle} </span>

                                    </Popup>

                                </div>
                            })}
                        </div>
                    </td>)}


                </tr>);
            })}
            </tbody>
        </table>

    </div>);
};
export default Table2